(function () {
  'use strict';
  if (customElements.get('occ-cart-discount')) return;
  let inFlight = false;
  function sectionTargets() {
    const targets = [];
    for (const id of ['main-cart-items', 'main-cart-footer']) {
      const node = document.getElementById(id);
      if (node?.dataset.id) targets.push({section: node.dataset.id, selector: '#' + id + (id === 'main-cart-items' ? ' .js-contents' : '')});
    }
    if (document.getElementById('CartDrawer')) targets.push({section: 'cart-drawer', selector: '#CartDrawer'});
    if (document.getElementById('cart-icon-bubble')) targets.push({section: 'cart-icon-bubble', selector: '#cart-icon-bubble', whole: true});
    return targets;
  }
  function renderSections(cart, targets) {
    // Validate every fragment before changing any visible price or line key.
    const parsed = targets.map(target => {
      const html = cart.sections?.[target.section];
      if (typeof html !== 'string' || !html.trim()) throw new Error('Cart section missing.');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = target.whole ? doc.body : doc.querySelector(target.selector);
      const destination = document.querySelector(target.selector);
      if (!source || !destination) throw new Error('Cart section unavailable.');
      return {source, destination};
    });
    for (const {source, destination} of parsed) destination.replaceChildren(...source.childNodes);
    for (const node of document.querySelectorAll('cart-items, cart-drawer, cart-drawer-items, #main-cart-footer')) node.classList.toggle('is-empty', cart.item_count === 0);
    const drawer = document.querySelector('cart-drawer.active');
    if (drawer && typeof window.trapFocus === 'function') window.trapFocus(drawer.querySelector('.drawer__inner'), drawer.querySelector('.drawer__close'));
  }
  function all() { return Array.from(document.querySelectorAll('occ-cart-discount')); }
  function busy(value) {
    inFlight = value;
    for (const node of all()) { node.setAttribute('aria-busy', String(value)); node.querySelectorAll('input,button').forEach(input => input.disabled = value); }
  }
  class CartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.client = window.OCCCartVariantCore.create({root: this.dataset.root || '/', shared: window});
      this.core = window.OCCCartDiscountCore.create({client: this.client, shared: window,
        withLock: task => navigator.locks ? navigator.locks.request('occ-cart-recovery', task) : task()});
      this.querySelector('[data-occ-discount-form]').addEventListener('submit', event => { event.preventDefault(); event.stopPropagation(); this.update(this.querySelector('input').value); });
      this.addEventListener('click', event => { const button = event.target.closest('[data-remove-code]'); if (button) this.update(button.dataset.removeCode, true); });
      this.querySelectorAll('input,button').forEach(input => input.disabled = inFlight);
      // GET only: a reload never reapplies a code or trusts local storage as evidence of acceptance.
      this.client.readCart().then(cart => { if (this.isConnected && !inFlight) this.showCodes(cart); }).catch(() => {});
    }
    showCodes(cart) {
      const box = this.querySelector('[data-occ-discount-codes]'); box.replaceChildren();
      if (!Array.isArray(cart.discount_codes)) return;
      for (const row of cart.discount_codes) {
        const p = document.createElement('p'), label = document.createElement('span'), remove = document.createElement('button');
        label.textContent = row.code + (row.applicable ? ' — accepted' : ' — not applicable');
        remove.type = 'button'; remove.textContent = 'Remove'; remove.dataset.removeCode = row.code; remove.setAttribute('aria-label', 'Remove code ' + row.code);
        remove.disabled = inFlight; p.append(label, remove); box.append(p);
      }
      if (cart.discount_codes.length) this.querySelector('details').open = true;
    }
    async update(code, remove = false) {
      if (inFlight) return;
      const fromDrawer = Boolean(this.closest('#CartDrawer'));
      const targets = sectionTargets();
      busy(true);
      this.querySelector('[data-occ-discount-message]').textContent = 'Checking your cart…';
      let result;
      try {
        result = await this.core.update(code, remove, {sections: [...new Set(targets.map(t => t.section))], sections_url: location.pathname});
        if (result.changed) {
          if (!targets.length) throw new Error('The updated cart cannot be displayed here. Review the current cart.');
          renderSections(result.cart, targets);
        }
        for (const node of all()) {
          node.dataset.state = result.state; node.showCodes(result.cart);
          node.querySelector('details').open = true;
          node.querySelector('[data-occ-discount-message]').textContent = result.message;
          node.querySelector('input').setAttribute('aria-invalid', String(['rejected', 'unconfirmed'].includes(result.state)));
          if (['applied','checkout','removed'].includes(result.state)) node.querySelector('input').value = '';
          else if (!remove) node.querySelector('input').value = code;
        }
        const visible = all().find(node => Boolean(node.closest('#CartDrawer')) === fromDrawer && node.getClientRects().length);
        visible?.querySelector('[data-occ-discount-message]').focus({preventScroll: true});
      } catch (error) {
        for (const node of all()) {
          node.dataset.state = 'error'; node.querySelector('[data-occ-discount-message]').textContent = error.message;
          node.querySelector('[data-occ-discount-review]').hidden = false;
        }
        this.querySelector('[data-occ-discount-message]')?.focus({preventScroll: true});
        // A write may have committed even when its response/sections failed. Fetch a fresh native cart.
        if (result?.changed || error.message.includes('before trying again')) {
          for (const node of all()) node.querySelectorAll('input,button').forEach(input => input.dataset.needsReview = 'true');
          document.querySelectorAll('[name="checkout"],.additional-checkout-buttons').forEach(node => { node.inert = true; node.setAttribute('aria-disabled', 'true'); });
        }
      } finally {
        busy(false);
        for (const node of all()) node.querySelectorAll('[data-needs-review]').forEach(input => input.disabled = true);
      }
    }
  }
  customElements.define('occ-cart-discount', CartDiscount);
})();
